module.exports = __webpack_public_path__ + "static/media/refer_screenshot.32a65794.PNG";